import Header from "./Header";
import Footer from "./Footer";
import ProductEventsBlock from "@/themes/kulturklub/ProductEventsBlock";

export default function KulturKlubTheme({ children, hideHeader, hideFooter, enableMoreProducts, products }) {
  return (
    <div className="min-h-dvh flex flex-col">
      {!hideHeader && <Header />}
      <main className="flex-1">
        {children}
      </main>
      {enableMoreProducts && (
        <ProductEventsBlock products={products} />
      )}
      {!hideFooter && <Footer />}
    </div>
  );
}